export { default as CoreBootMainModule } from './module';
